// @ts-nocheck
import type * as Types from '../../../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DonorVerifyEmailMutationVariables = Types.Exact<{
  input: Types.DonorVerifyEmailInput;
}>;


export type DonorVerifyEmailMutation = { __typename?: 'Mutation', donorVerifyEmail: { __typename?: 'DonorVerifyEmailResult', donorSignInEmailSent: boolean } };

export type DonorSignInWithTokenMutationVariables = Types.Exact<{
  input: Types.DonorSignInWithTokenInput;
}>;


export type DonorSignInWithTokenMutation = { __typename?: 'Mutation', donorSignInWithToken: { __typename?: 'AuthResult', accessToken: string } };


export const DonorVerifyEmailDocument = /*#__PURE__*/ gql`
    mutation DonorVerifyEmail($input: DonorVerifyEmailInput!) {
  donorVerifyEmail(input: $input) {
    donorSignInEmailSent
  }
}
    `;

/**
 * __useDonorVerifyEmailMutation__
 *
 * To run a mutation, you first call `useDonorVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDonorVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [donorVerifyEmailMutation, { data, loading, error }] = useDonorVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDonorVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<DonorVerifyEmailMutation, DonorVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DonorVerifyEmailMutation, DonorVerifyEmailMutationVariables>(DonorVerifyEmailDocument, options);
      }
export type DonorVerifyEmailMutationHookResult = ReturnType<typeof useDonorVerifyEmailMutation>;
export const DonorSignInWithTokenDocument = /*#__PURE__*/ gql`
    mutation DonorSignInWithToken($input: DonorSignInWithTokenInput!) {
  donorSignInWithToken(input: $input) {
    accessToken
  }
}
    `;

/**
 * __useDonorSignInWithTokenMutation__
 *
 * To run a mutation, you first call `useDonorSignInWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDonorSignInWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [donorSignInWithTokenMutation, { data, loading, error }] = useDonorSignInWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDonorSignInWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<DonorSignInWithTokenMutation, DonorSignInWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DonorSignInWithTokenMutation, DonorSignInWithTokenMutationVariables>(DonorSignInWithTokenDocument, options);
      }
export type DonorSignInWithTokenMutationHookResult = ReturnType<typeof useDonorSignInWithTokenMutation>;